"use client";
import { Stack } from "@chakra-ui/react";
import { SimpleList } from "@/components/list";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import virtuzzo from "public/privateCloud/virtuozzo-paas.jpg";

type ChildrenProps = {
  descPoints: string[];
  subText: string;
  subTextPoints: string[];
};

const DescComp = (props: ChildrenProps) => {
  const TextVariant = useTextVariant();
  const { descPoints, subText, subTextPoints } = props;
  return (
    <Stack gap={3} color="text.100">
      <SimpleList points={descPoints} />
      <Text variant={TextVariant} color="text.100" fontWeight={600}>
        {subText}
      </Text>
      <SimpleList points={subTextPoints} />
    </Stack>
  );
};

export const OFFERS_CONSTANTS = {
  title: "Public IPv4 / IPv6 by OneMind Services ",
  description:
    "We provide IPv4 and IPv6 address blocks under industry-standard best practices—ensuring routing reliability, address integrity, and access scalability. You can bind addresses to: ",
  children: (
    <DescComp
      descPoints={[
        "Cloud Instances",
        "Load Balancers",
        "Containerized Workloads",
        "VPN Gateways and Edge Appliances",
      ]}
      subText="Features include: "
      subTextPoints={[
        "Static IPv4/IPv6 allocations",
        "BYOIP (Bring Your Own IP) support",
        "Region-specific availability",
        "Reverse DNS and PTR record management",
      ]}
    />
  ),
  image: virtuzzo,
  imageHeight: "480px",
};
